module.exports = __webpack_public_path__ + "img/12-02.64d4bb92.png";